<template>

  <div>


    <!-- Tür seçimi -->


    <!-- Grafik alanı -->
    <!-- <div ref="chart" style="width: 100%; height: 450px; margin-top: 20px;"></div> -->
    <v-toolbar color="indigo" dark>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <v-toolbar-title>
        <v-select :items="items" v-model="chartType">

        </v-select>


        <!-- <select v-model="chartType" @change="renderChart">
      <option value="line">Çizgi (Line)</option>
      <option value="bar">Çubuk (Bar)</option>
      <option value="pie">Pasta (Pie)</option>
      <option value="donut">Halka (Donut)</option>
    </select > -->
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="exportExcel2">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="chartDiv">
      <div v-for="(chart,index) in lsData" :key="'chart'+index"> 
        <v-card elevation="2">

          <v-card-text  >
   




            <v-container>
              <v-row>
                <v-col xs="12" sm="12" md="3" lg="3" xl="3">
         <div class="dvTable">
              <h3>{{ chart.header }}</h3>
   
    <table border="1" cellpadding="5">
  <thead>
    <tr>
      <th>Şeçenekler</th>
      <th v-for="year in getYears(chart)" :key="year">{{ year }}</th>
      <th>Toplam</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="label in getLabels(chart)" :key="'lb'+label">
      <td>{{ label }}</td>
      <td v-for="year in getYears(chart)" :key="year">
        {{ buildPivot(chart)[label]?.[year] ?? 0 }}
      </td>
      <td>
        {{ Object.values(buildPivot(chart)[label] || {}).reduce((s,v)=>s+v,0) }}
      </td>
    </tr>
    <!-- Kolon toplamları -->
    <tr>
      <td><b>Kolan Toplamları</b></td>
      <td v-for="year in getYears(chart)" :key="year">
        <b>{{ buildColumnTotals(chart)[year] }}</b>
      </td>
      <td><b>{{ buildGrandTotal(chart) }}</b></td>
    </tr>
  </tbody>
</table>

            </div>

                </v-col>
                <v-col cols="9">
                  <!-- <PlotlyChart :data="chart.datas" :labels="chart.labels" :title="chart.header" :type="chartType">
                  </PlotlyChart> -->
                  <PlotlyChart v-for="(itemValue,index) in chart.items" :data="itemValue.datas" :labels="itemValue.labels" :title="`${itemValue.year}`" :type="chartType" :key="'pchart_'+index">
                  </PlotlyChart> 
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>


      </div>
    </div>





  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import PlotlyChart from "@/components/PlotlyChart.vue";
import FormService from "@/services/FormService";
import Plotly from "plotly.js-dist";
import { tableToExcel } from '@/plugins/custom';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { h } from "vue";
export default {
  name: "anketRapor",
  components: { PlotlyChart },
  data() {
    return {
      lsData: [],
      chartType: "bar", // Varsayılan tür
      items: ['line', 'bar', 'pie', 'donut'],

    };
  },
  mounted() {

    this.databind();
  },
  computed: {
resimGenisligi(){
  if (this.chartType=='pie' || this.chartType=='donut' ) {
    return { width: 650, height: 350 };
  } else {
   
     return { width: 500, height: 280 };
  }
}
  },

  methods: {



async exportExcel2() {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Anket Rapor");

  let currentRow = 1;
  const allPlots = document.querySelectorAll(".js-plotly-plot");
  let globalPlotIndex = 0;

  for (let i = 0; i < this.lsData.length; i++) {
    const chart = this.lsData[i];

    const sectionStartRow = currentRow; // tablo + grafik aynı hizadan başlasın

    // Başlık
    worksheet.getCell(`A${currentRow}`).value = chart.header;
    worksheet.getCell(`A${currentRow}`).font = {
      bold: true,
      size: 14
    };
    currentRow += 2;

    // TABLO
    const years = this.getYears(chart);
    const labels = this.getLabels(chart);
    const pivot = this.buildPivot(chart);

    worksheet.addRow(["Seçenekler", ...years, "Toplam"]);
    currentRow++;

    labels.forEach(label => {
      const row = [label];

      years.forEach(year => {
        row.push(pivot[label]?.[year] ?? 0);
      });

      row.push(
        Object.values(pivot[label] || {}).reduce((sum, val) => sum + val, 0)
      );

      worksheet.addRow(row);
      currentRow++;
    });

    const colTotals = this.buildColumnTotals(chart);
    worksheet.addRow([
      "Kolon Toplamları",
      ...years.map(y => colTotals[y]),
      this.buildGrandTotal(chart)
    ]);

    const tableEndRow = currentRow;
    currentRow += 2;

    // GRAFİKLERİ SAĞ TARAFA KOY
    let graphRow = sectionStartRow + 1;

    for (let j = 0; j < chart.items.length; j++) {
      const plotDiv = allPlots[globalPlotIndex];

      if (plotDiv) {
        try {
          const imgData = await Plotly.toImage(plotDiv, {
            format: "png",
            width: 700,
            height: 350
          });

          const imageId = workbook.addImage({
            base64: imgData,
            extension: "png"
          });

          worksheet.addImage(imageId, {
            tl: { col: 7, row: graphRow-1 }, // H sütunu
            ext: this.resimGenisligi
          });

          graphRow += 16;
        } catch (err) {
          console.error(err);
        }
      }

      globalPlotIndex++;
    }

    // sonraki blok için satır ayarı
    currentRow = Math.max(currentRow, graphRow, tableEndRow + 5);
  }

  // kolon genişlikleri
  worksheet.columns = [
    { width: 22 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 5 },  // boşluk
    { width: 20 }
  ];

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }),
    "anket-rapor.xlsx"
  );
},

 getYears(group) {
  const years = new Set();
  group.items.forEach(item => years.add(item.year));

 return Array.from(years).map(y => y.toString()).sort();

},


 getLabels(group) {
  const labels = new Set();
  group.items.forEach(item => {
    item.labels.forEach(l => {
      labels.add(l);
      //if (l && l !== "undefined") labels.add(l);
    });
  });
  return Array.from(labels);
},


//  buildPivot(group) {
//   const result = {};
//   group.items.forEach(item => {
//     item.labels.forEach((label, idx) => {
//       if (label && label !== "undefined") {
//         if (!result[label]) result[label] = {};
//         result[label][item.year] = (result[label][item.year] || 0) + item.datas[idx];
//       }
//     });
//   });
//   return result;
// },

buildPivot(group) {
  const result = {};
  group.items.forEach(item => {
    item.labels.forEach((label, idx) => {
      if (label && label !== "undefined") {
        if (!result[label]) result[label] = {};
        result[label][item.year] = (result[label][item.year] || 0) + item.datas[idx];
      }
    });
  });
  return result;
},

// Kolon toplamlarını hesapla
buildColumnTotals(group) {
  const pivot = this.buildPivot(group);
  const years = this.getYears(group);
  const totals = {};
  years.forEach(year => {
    totals[year] = 0;
    Object.keys(pivot).forEach(label => {
      totals[year] += pivot[label][year] || 0;
    });
  });
  return totals;
},

// Genel toplam
buildGrandTotal(group) {
  const colTotals = this.buildColumnTotals(group);
  return Object.values(colTotals).reduce((sum, v) => sum + v, 0);
}
,




    exportExcel() {
      // console.log("object,", document.getElementById("tblFormDataHeader").parentElement);
      let outTable = document.getElementsByClassName("dvTable");

      var innerDiv = document.createElement('div');
      innerDiv.className = 'block-2';
      for (let i = 0; i < outTable.length; i++) {
        innerDiv.appendChild(outTable[i].cloneNode(true));
      }
      // The variable iDiv is still good... Just append to it.


      console.log("outTable", innerDiv);
      //let table = outTable[0].querySelector("table");

      // tableToExcel("tblFormData", this.result.formname);
      tableToExcel(innerDiv, "gsdgsd");

    },
    databind() {
      FormService.anketRapor(this.$route.params.id).then((result) => {
        console.log("anket",result.data);
        this.lsData = result.data;
      }).catch((err) => {

      });
    },

  },
};
</script>

<style scoped>
.chart-container {
  max-width: 1000px;
  margin: auto;
  text-align: center;
}

select {
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

table.table,
td,
th {
  border: 1px solid #ddd;
  text-align: left;
}

table.table {
  border-collapse: collapse;
  width: 100%;
}

.table th,
td {
  padding: 10px;
}

.chartDiv {
  overflow-y: scroll;
  height: calc(100vh - 165px);
}
</style>
